import * as React from "react";
import { ResourcesConstants } from "../../models/resources.constants";
import Resource from "../../presentations/Resource";

const ResourceContainer = () => {
  return (
    <div className="flex flex-wrap">
      {
        ResourcesConstants.Resources && ResourcesConstants.Resources.map((resource: any, index) => (
          <Resource key={index} resource={resource}></Resource>
        ))}
    </div>
  );
};

export default ResourceContainer;
